<template>
  <div class="FullScr">
    <div id="fullpage" class="lg" v-if="(size == 'lg') & !noHeader">
      <div class="modal-content w-100 h-100" :style="!InheritanceTheme ? 'background:#f2f8fa !important' : 'background:var(--sidebar-action-bg);'">
        <div class="modal-header">
          <slot name="header"> </slot>
          <button class="fas fa-times btn-danger" @click="Close"></button>
        </div>
        <div class="modal-body" :style="!InheritanceTheme ? 'background:#f2f8fa !important' : 'background:var(--sidebar-action-bg) !important;'">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer justify-content-start" dir="rtl">
          <button class="btn btn-danger" @click="Close">بستن</button>
        </div>
      </div>
    </div>

    <div id="fullpage" class="lg" v-if="(size == 'lg') & noHeader">
      <div class="modal-content w-100 h-100" :style="!InheritanceTheme ? 'background:#f2f8fa !important' : 'background:var(--sidebar-action-bg);'">
        <div class="modal-header">
          <slot name="header"> </slot>
        </div>
        <div class="modal-body" :style="!InheritanceTheme ? 'background:#f2f8fa !important' : 'background:var(--sidebar-action-bg) !important;'">
          <slot name="body"></slot>
        </div>
      </div>
    </div>

    <div id="fullpage" class="md" v-if="size == 'md'">
      <div class="modal-content w-100 h-100" :style="!InheritanceTheme ? 'background:#f2f8fa !important' : 'background:var(--sidebar-action-bg);'">
        <div class="modal-header justify-content-end">
          <slot name="headerMd"> </slot>
        </div>
        <div class="modal-body" :style="!InheritanceTheme ? 'background:#f2f8fa !important' : 'background:var(--sidebar-action-bg) !important;'">
          <slot name="body"></slot>
        </div>
      </div>
    </div>

    <div id="fullpage" class="sm" v-if="size == 'md-header'">
      <div class="modal-content w-100 h-100" :style="!InheritanceTheme ? 'background:#f2f8fa !important' : 'background:var(--sidebar-action-bg);'">
        <div class="modal-header justify-content-end">
          <slot name="headerMd"> </slot>
        </div>
        <div class="modal-body" :style="!InheritanceTheme ? 'background:#f2f8fa !important' : 'background:var(--sidebar-action-bg) !important;'">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['InheritanceTheme', 'size', 'noHeader', 'zIndex'],
  data() {
    return {}
  },
  created() {
    let divModal = document.getElementsByClassName('FullScr')[0]

    if (divModal != undefined) {
      if ((this.zIndex != undefined) & (this.zIndex == true)) {
        divModal.classList.add('zIndex10')
      } else {
        divModal.classList.add('zIndex5')
      }
    }
  },
  mounted() {
    window.addEventListener('click', this.Clickhandler)
  },
  methods: {
    ...mapActions('layout'),

    Close() {
      this.$store.state.Modal = false
    },
    Clickhandler(e) {
      if (!e.target.classList.contains('Modal')) {
        this.Close()
      }
    },
  },
  mounted() {
    // this.toggleSidebarclose()
  },
}
</script>
<style scoped>
#fullpage {
  display: block;
  position: absolute;
  position: fixed;
  /* min-height: 20vh;
  max-height: 75vh; */
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  color: var(--sidebar-color-item) !important;
  border-radius: 0.5rem;
  z-index: 9999;

  min-width: 1vw;
  min-height: 1vh;
}

.md {
  max-width: 45vw;
  max-height: 50vh;
}

.sm {
  max-width: 30vw;
  max-height: 38vh;
}

.lg {
  max-width: 65vw;
  max-height: 80vh;
}

.zIndex10 {
  z-index: 1 !important;
}

.zIndex5 {
  z-index: 2 !important;
}

.FullScr {
  position: absolute !important;
  top: 0rem;
  left: 0rem;
  width: 100% !important;
  height: 100% !important;
  background: rgba(12, 12, 12, 0.745) !important;
  /* z-index: 5 !important; */
}

.bg-Header {
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
}

.Body {
  background: var(--sidebar-color-item) !important;
}

.header {
  position: sticky !important;
  top: 0;
  z-index: 2000;
}

.footer {
  /* position: sticky !important;
    bottom:0;
    z-index:2000; */
  display: flex;
  align-items: flex-end;
}

.fa-times:hover {
  color: red !important;
  transition: 0.3s;
}

.fa-times {
  transition: 0.3s;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .modal-content {
    width: 100vw !important;
  }
  #fullpage {
    position: unset !important;
    margin: 0px !important;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
}
</style>
